import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setPlaylistEpisodes } from "../../actions/set-Playlist-Episodes";
import { useHistory, useLocation, useParams } from "react-router-dom";
import DB from "../../other/local-db";
import { generateUrl } from "../../other/generate-url";
import EpisodeItem from "./EpisodeItem"; // Updated component
import Slider from "react-slick";
import { Box, Typography, Select, MenuItem } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const Seasons = ({ seasonData, cover }) => {
  const [seasons, setSeasons] = useState([]);
  const [streamStat, setStreamStat] = useState({});
  const [selectedSeason, setSelectedSeason] = useState();

  const { stream_id } = useParams();
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!seasonData) return;

    const s = Object.keys(seasonData).map((x) => {
      return {
        id: parseInt(x),
        name: "Season " + x,
        episodes: seasonData[x].map((y) => {
          return {
            ...y,
            episode_num: parseInt(y.episode_num),
            url:
              y.url ||
              y.direct_source ||
              generateUrl("series", y.id, y.container_extension),
            url2: generateUrl("series", y.id, y.container_extension),
          };
        }),
      };
    });

    if (s.length > 0) {
      setSeasons(s);

      let stat = DB.findOne("series", stream_id);
      if (!stat) {
        stat = {
          id: stream_id,
          season: s[0].id,
          episode: s[0].episodes[0].episode_num,
          start: 0,
        };
      }

      stat.season = parseInt(stat.season);
      stat.episode = parseInt(stat.episode);

      if (stat.tot > 95 || stat.tot < 3) {
        stat.tot = 0;
        let season = s.find((x) => x.id === stat.season);

        if (
          season.episodes[season.episodes.length - 1].episode_num > stat.episode
        ) {
          stat.episode++;
        } else {
          season = s.find((x) => x.id === stat.season + 1);
          if (season && season.episodes && season.episodes.length > 0) {
            stat.season = season.id;
            stat.episode = season.episodes[0].episode_num;
          } else {
            stat = {
              id: stream_id,
              season: s[0].id,
              episode: s[0].episodes[0].episode_num,
              start: 0,
            };
          }
        }
      }

      setSelectedSeason(stat.season);
      setStreamStat(stat);
    }
  }, [seasonData, stream_id]);

  const playEpisode = (episode) => {
    const list = seasons
      .find((x) => x.id === selectedSeason)
      .episodes.map((x) => {
        return { ...x, id: x.info.id };
      });
    dispatch(setPlaylistEpisodes(list));
    history.push(
      location.pathname.replace(
        "info",
        `play/season/${selectedSeason}/episode/${episode}`
      )
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          right: "-35px",
          zIndex: 1,
          width: "50px",
          height: "100%",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <ChevronRightIcon style={{ color: "white", fontSize: "2rem" }} />
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          left: "-35px",
          zIndex: 1,
          width: "50px",
          height: "100%",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <ChevronLeftIcon style={{ color: "white", fontSize: "2rem" }} />
      </div>
    );
  }

  return (
    seasons.length > 0 && (
      <Box
        sx={{
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderRadius: "8px",
          padding: "2rem",
          marginLeft: "2rem",
          marginTop: "2rem",
          marginRight: "2rem",
        }}
      >
        <Box sx={{ color: "white", paddingBottom: "1rem" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Select
              value={selectedSeason || (seasons[0] && seasons[0].id)}
              onChange={(e) => {
                setSelectedSeason(parseInt(e.target.value));
              }}
              sx={{
                minWidth: "120px",
                backgroundColor: "rgba(0,0,0,0.5)",
                color: "white",
                "& .MuiSelect-icon": {
                  color: "white",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "white",
                },
              }}
            >
              {seasons.map((x) => (
                <MenuItem value={x.id} key={"season-" + x.id}>
                  {x.name} ({x.episodes.length} episodes)
                </MenuItem>
              ))}
            </Select>
          </Box>
          <Box
            sx={{
              position: "relative",
              margin: "1rem",
              "& .slick-slide": {
                padding: "0 0.25rem",
              },
            }}
          >
            {streamStat && seasons.find((x) => x.id === selectedSeason) && (
              <Slider {...settings}>
                {seasons
                  .find((x) => x.id === selectedSeason)
                  .episodes.map((ep) => (
                    <EpisodeItem
                      key={"ep-" + ep.episode_num}
                      episode={ep.episode_num}
                      image={ep.info.movie_image || cover}
                      title={ep.title}
                      selected={ep.episode_num === streamStat.episode}
                      playEpisode={playEpisode}
                    />
                  ))}
              </Slider>
            )}
          </Box>
        </Box>
      </Box>
    )
  );
};

export default Seasons;
